import {FC} from 'react'
import {useTranslation} from 'react-i18next'

interface BadgeColorSOProps {
  status: number
  text: string
  role: string
  approved_level?: string
}

export const BadgeColorSO: FC<BadgeColorSOProps> = ({text, status, role, approved_level}) => {
  const {t} = useTranslation()

  const handleStatusWaiting = (status: string, level: any) => {
    if (status.match('Sales Anper') || level == 0) {
      return t(status)
    }
    let text = status?.split(' ')
    let newStatus = t('Waiting for Appproval').replace('#ID', text[3] || '')
    return newStatus
  }
  const handleStatusProccess = (status: string) => {
    let text = status?.split(' ')
    let newStatus = t('Process for Appproval').replace('#ID', text[3] || '')
    return newStatus
  }

  return (
    <>
      {text == 'Pengajuan Amandemen' ||
      text == 'Amandemen' ||
      text == 'Menunggu Persetujuan Amandemen' ||
      text == 'Diamandemen Customer' ||
      text == 'Telah Diamandemen' ? (
        <span className='badge badge-light-info'>{t('Amandemen')}</span>
      ) : status === 0 ? (
        <span className='badge badge-light-primary'>{handleStatusWaiting(text, approved_level)}</span>
      ) : status === 1 ? (
        <span className='badge badge-light-primary'>{handleStatusProccess(text)}</span>
      ) : status === 2 ? (
        <span className='badge badge-light-warning'>{t(text)}</span>
      ) : status === 3 ? (
        <span className='badge badge-light-primary'>{t(text)}</span>
      ) : status === 4 ? (
        <span className='badge badge-light-success'>{t(text)}</span>
      ) : status === 5 ? (
        <span className='badge badge-light-primary'>{t(text)}</span>
      ) : status === 6 ? (
        <span className='badge badge-light-success'>{t(text)}</span>
      ) : status === 7 ? (
        <span className='badge badge-light-success'>{t(text)}</span>
      ) : status === 8 ? (
        <span className='badge badge-light-primary'>{t(text)}</span>
      ) : status === 9 ? (
        <span className='badge badge-light-warning'>{t(text)}</span>
      ) : status === 10 ? (
        <span className='badge badge-light-primary'>{t(text)}</span>
      ) : status === 11 ? (
        <span className='badge badge-light-success'>{t(text)}</span>
      ) : status === 13 ? (
        <span className={`badge ${role === 'null' ? 'badge-light-primary' : 'badge-light-danger'}`}>
          {role === 'null' ? 'Pending' : t(text)}
        </span>
      ) : (
        <span className='badge badge-light-danger'>{t(text)}</span>
      )}
    </>
  )
}
